var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingPermissions = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 325,
  height: 254,
  viewBox: "0 0 325 254",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Illustration"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector 22",
  d: "M85.8654 136.054C82.9629 136.054 80.2217 135.248 79.2139 134.845C83.0435 132.829 90.7028 125.532 90.7028 112.471C90.7028 99.4101 83.0435 92.1136 79.2139 90.098C80.4232 89.6949 83.5676 88.8887 86.4701 88.8887C90.0982 88.8887 104.611 92.5168 104.611 112.471C104.611 132.426 89.4935 136.054 85.8654 136.054Z",
  fill: "var(--illustration-brand)",
  fillOpacity: 0.07
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 19",
  d: "M255.781 236.431H246.106V19.3503C246.106 12.5779 242.075 11.2879 240.06 11.4894C241.47 11.2879 245.26 10.8848 249.13 10.8848C253.967 10.8848 255.781 13.9082 255.781 16.9316V236.431Z",
  fill: "var(--illustration-brand)",
  fillOpacity: 0.07
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 18",
  d: "M173.544 158.426L180.196 123.959C176.81 122.508 175.56 120.532 175.358 119.726H185.638C189.266 119.726 192.289 116.098 192.289 111.865C192.289 107.632 189.266 104.004 185.638 104.004H172.335C174.27 96.2643 183.219 93.9262 187.452 93.7246C194.708 93.7246 202.569 99.7714 202.569 109.446C202.569 117.186 196.925 122.346 194.104 123.959L200.15 158.426H173.544Z",
  fill: "var(--illustration-brand)",
  fillOpacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410",
  d: "M121.074 188.522C112.026 179.474 105.273 168.999 100.817 157.821",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_2",
  d: "M142.704 43.3482C134.929 47.4928 127.627 52.8419 121.073 59.3956C114.444 66.0243 109.048 73.4187 104.884 81.294",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_3",
  d: "M185.638 32.6523C207.256 32.6524 228.873 40.2819 246.106 55.5409",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_4",
  d: "M263.843 76.79C283.674 109.612 280.993 152.224 255.801 182.399",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_5",
  d: "M246.274 55.6666C253.26 61.8598 259.144 69.0039 263.832 76.7926",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_6",
  d: "M241.087 196.516C224.772 209.017 205.204 215.266 185.638 215.266",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_7",
  d: "M185.638 193.498C151.996 193.498 123.933 169.608 117.49 137.867",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_8",
  d: "M136.463 74.7938C149.047 62.2071 166.434 54.4219 185.639 54.4219",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_9",
  d: "M203.629 56.7895C220.821 61.3945 236.257 72.5591 245.859 89.191",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_10",
  d: "M128.743 180.799C119.291 171.338 112.184 159.533 108.368 146.332",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_11",
  d: "M242.477 67.0631C227.926 52.5255 207.831 43.5352 185.637 43.5352C153.794 43.5352 126.273 62.0419 113.244 88.8864",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_12",
  d: "M255.849 85.2598C261.977 96.6115 265.455 109.604 265.455 123.409C265.455 137.266 261.951 150.304 255.78 161.686",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_13",
  d: "M255.853 161.69C253.129 166.711 249.9 171.376 246.248 175.631",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 410_14",
  d: "M242.477 180.855C227.926 195.393 207.831 204.383 185.637 204.383C166.374 204.383 148.692 197.611 134.844 186.317",
  stroke: "var(--illustration-brand)",
  strokeOpacity: 0.21,
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 15",
  d: "M74.9805 152.379L53.2119 113.075L74.9805 73.166H100.377L122.75 113.075L99.7725 152.379H74.9805Z",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 413",
  d: "M85.8643 88.8877C96.098 88.8877 104.609 99.3135 104.609 112.471C104.609 125.628 96.0979 136.053 85.8643 136.053C75.6307 136.053 67.1192 125.628 67.1191 112.471C67.1191 99.3136 75.6306 88.8879 85.8643 88.8877Z",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 413_2",
  d: "M79.2139 134.577C85.9832 130.811 90.7028 122.329 90.7028 112.469C90.7028 102.61 85.9832 94.1278 79.2139 90.3613",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 15_2",
  d: "M75.5852 152.379H59.2588L37.4902 113.075L59.2588 73.166H74.9806",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 153",
  x1: 134.844,
  y1: 120.936,
  x2: 134.844,
  y2: 237.035,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 154",
  x1: 134.239,
  y1: 236.43,
  x2: 256.385,
  y2: 236.43,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 13",
  d: "M255.78 236.431V17.1771C255.78 13.7432 252.924 10.9984 249.493 11.135L140.046 15.4911C136.802 15.6202 134.239 18.2872 134.239 21.5332V103.401",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 14",
  d: "M246.106 236.43V17.74C246.106 14.3215 243.275 11.5827 239.858 11.6966L209.825 12.6976",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 408",
  d: "M117.913 104.004H185.033C189.04 104.004 192.289 107.523 192.289 111.865C192.289 116.206 189.04 119.726 185.033 119.726H119.122",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  d: "M186.847 93.1211C195.863 93.1211 203.174 100.431 203.174 109.447C203.174 115.692 199.666 121.118 194.515 123.863L200.755 159.031H172.939L179.695 124.127C177.544 123.077 175.659 121.566 174.165 119.726H175.765C177.028 121.087 178.538 122.216 180.226 123.04L181.059 123.446L180.883 124.356L174.405 157.822H199.312L193.324 124.074L193.17 123.209L193.946 122.796C198.719 120.252 201.965 115.228 201.965 109.447C201.965 101.099 195.196 94.3301 186.847 94.3301C180.417 94.3304 174.925 98.345 172.74 104.004H171.452C173.694 97.664 179.739 93.1214 186.847 93.1211Z",
  fill: "var(--illustration-brand)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtract_2",
  d: "M186.847 87.0742C199.203 87.0742 209.221 97.0909 209.221 109.447C209.221 117.162 205.315 123.965 199.374 127.987L206.802 163.264H166.893L174.986 128.42C171.598 126.297 168.82 123.291 166.972 119.726H168.345C170.087 122.855 172.599 125.498 175.628 127.396L176.359 127.854L176.164 128.693L168.415 162.055H205.312L198.19 128.236L198.023 127.441L198.696 126.986C204.319 123.179 208.012 116.744 208.012 109.447C208.012 97.7589 198.535 88.2832 186.847 88.2832C177.041 88.2835 168.793 94.9536 166.391 104.004H165.143C167.574 94.2787 176.368 87.0746 186.847 87.0742Z",
  fill: "var(--illustration-brand)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156",
  x1: 255.177,
  y1: 123.96,
  x2: 276.945,
  y2: 123.96,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_2",
  x1: 234.48,
  y1: 75.1193,
  x2: 242.945,
  y2: 66.6537,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_3",
  x1: 136.796,
  y1: 75.1151,
  x2: 121.074,
  y2: 59.3933,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_4",
  x1: 185.638,
  y1: 54.4219,
  x2: 185.638,
  y2: 32.6533,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_5",
  x1: 136.796,
  y1: 172.801,
  x2: 121.074,
  y2: 188.522,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_6",
  x1: 185.638,
  y1: 193.498,
  x2: 185.638,
  y2: 215.267,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 156_7",
  x1: 220.407,
  y1: 184.182,
  x2: 231.292,
  y2: 203.034,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("line", {
  id: "Line 157",
  x1: 37.4902,
  y1: 113.075,
  x2: 53.212,
  y2: 113.075,
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411",
  cx: 185.638,
  cy: 192.895,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_2",
  cx: 185.638,
  cy: 214.662,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_3",
  cx: 231.594,
  cy: 203.777,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_4",
  cx: 277.55,
  cy: 123.959,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_5",
  cx: 235.222,
  cy: 74.3769,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_6",
  cx: 185.638,
  cy: 55.0254,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_7",
  cx: 120.332,
  cy: 58.6523,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_8",
  cx: 136.054,
  cy: 74.3769,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_9",
  cx: 136.054,
  cy: 173.543,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_10",
  cx: 120.332,
  cy: 188.055,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 411_11",
  cx: 185.638,
  cy: 33.2578,
  r: 2.41873,
  fill: "var(--illustration-brand-subtle)",
  stroke: "var(--illustration-brand)",
  strokeWidth: 1.20937
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtract_3",
  d: "M185.638 65.3027C218.031 65.3028 244.292 91.5634 244.292 123.957C244.292 156.351 218.031 182.611 185.638 182.611C153.244 182.611 126.983 156.351 126.983 123.957C126.983 122.534 127.035 121.122 127.135 119.725H185.032C189.265 119.725 192.289 116.097 192.289 111.864C192.289 107.631 188.66 104.003 185.032 104.003H130.466C138.631 81.4327 160.25 65.3027 185.638 65.3027Z",
  fill: "var(--illustration-brand)",
  fillOpacity: 0.07
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingPermissions);
export default ForwardRef;